import React from 'react';
import { Paper, Typography } from '@mui/material';
import { typography } from '../styles/globals.js';

// Parse text with [[highlighted]] markers and render with underlines
const parseHighlightedText = (text) => {
  if (!text) return null;

  const parts = [];
  let lastIndex = 0;
  const regex = /\[\[([^\]]+)\]\]/g;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    // Add the highlighted text (without brackets)
    parts.push(
      <span
        key={match.index}
        style={{
          textDecoration: 'underline',
          textDecorationColor: '#888888',
          textUnderlineOffset: '3px',
        }}
      >
        {match[1]}
      </span>
    );

    lastIndex = match.index + match[0].length;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : text;
};

const RiskSummaryText = ({ summary }) => {
  if (!summary) {
    return null;
  }

  const highlightedContent = parseHighlightedText(summary);

  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 2,
        border: '1px solid #D9DDF0',
      }}
    >
      <Typography
        sx={{
          fontWeight: typography.fontWeights.semibold,
          fontSize: typography.fontSizes.h3,
          mb: 1,
        }}
      >
        Summary
      </Typography>
      <Typography
        component="div"
        sx={{
          fontSize: typography.fontSizes.medium,
          lineHeight: 1.6,
          color: '#333',
        }}
      >
        {highlightedContent}
      </Typography>
    </Paper>
  );
};

export default RiskSummaryText;
